export const AVATAR_PIXELS = 256;
export const AVATAR_ACCEPT = "image/jpeg,image/png,image/webp";

/** Centre-crops to a square and resizes, so uploads are tiny and uniform. */
export async function cropAvatar(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  try {
    const side = Math.min(bitmap.width, bitmap.height);
    const canvas = document.createElement("canvas");
    canvas.width = AVATAR_PIXELS;
    canvas.height = AVATAR_PIXELS;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Could not process the image");
    context.drawImage(
      bitmap,
      (bitmap.width - side) / 2,
      (bitmap.height - side) / 2,
      side,
      side,
      0,
      0,
      AVATAR_PIXELS,
      AVATAR_PIXELS,
    );
    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (blob) =>
          blob
            ? resolve(blob)
            : reject(new Error("Could not process the image")),
        "image/webp",
        0.85,
      );
    });
  } finally {
    bitmap.close();
  }
}
